import { env } from 'Shared/constants/env';

import { PriceEvents } from './constants';
import { PriceModel, PriceEvent } from './types';

export const initialPriceModel: PriceModel = {
  status: 'idle',
  context: {
    frequency: null,
    dayOfWeek: null,
    dayOfMonth: null,
    biweeklyDate: null,
    semiMonthlyDates: null,
    downpayment: null,
  },
};

export function transition(
  model: PriceModel = initialPriceModel,
  event: PriceEvent
): PriceModel {
  switch (event.type) {
    case PriceEvents.SELECT_FREQUENCY: {
      const frequency = event.value;

      // Weekly or Every Two Weeks → WeekdaySelector
      if (frequency === 'weekly' || frequency === 'biWeekly') {
        return {
          status: 'selectingDayOfWeek',
          context: {
            ...initialPriceModel.context,
            frequency,
          },
        };
      }

      // Once a Month → DayOfMonthSelector
      if (frequency === 'monthly') {
        return {
          status: 'selectingDayOfMonth',
          context: {
            ...initialPriceModel.context,
            frequency,
          },
        };
      }

      // Twice a Month → SemiMonthlySelector
      if (frequency === 'semiMonthly') {
        return {
          status: 'selectingSemiMonthlyDates',
          context: {
            ...initialPriceModel.context,
            frequency,
          },
        };
      }

      return {
        status: 'selectingFrequency',
        context: {
          ...initialPriceModel.context,
          frequency,
        },
      };
    }

    case PriceEvents.SELECT_DAY_OF_WEEK: {
      const { frequency } = model.context;

      if (frequency === 'biWeekly' && env.paymentFlexibilityEveryTwoWeeks) {
        return {
          status: 'selectingBiweeklyDate',
          context: {
            ...model.context,
            dayOfWeek: event.value,
            biweeklyDate: null,
          },
        };
      }

      return {
        status: 'ready',
        context: {
          ...model.context,
          dayOfWeek: event.value,
        },
      };
    }

    case PriceEvents.SELECT_BIWEEKLY_START_DATE: {
      return {
        status: 'ready',
        context: {
          ...model.context,
          biweeklyDate: event.value,
        },
      };
    }

    case PriceEvents.SELECT_DAY_OF_MONTH: {
      return {
        status: 'ready',
        context: {
          ...model.context,
          dayOfMonth: event.value,
        },
      };
    }

    case PriceEvents.SELECT_SEMI_MONTHLY_DATES: {
      return {
        status: 'ready',
        context: {
          ...model.context,
          semiMonthlyDates: event.value,
        },
      };
    }

    case PriceEvents.JUMP_TO_STATE: {
      const { status, context } = event.value;

      return {
        status,
        context: {
          ...initialPriceModel.context,
          ...context,
        },
      };
    }

    case PriceEvents.RESET:
      return initialPriceModel;

    default:
      return model;
  }
}
